import { cn } from '@exam-room/utils';

interface TableRowProps extends React.HTMLAttributes<HTMLTableRowElement> {
  className?: string;
}

export default function TableRow({ children, className, ...props }: TableRowProps) {
  return (
    <tr className={cn('border-border-divider border-b', className)} {...props}>
      {children}
    </tr>
  );
}
